import React from "react";
import Button from "../../../containers/button/button";
import classes from "./card.module.css";
import { useNavigate } from "react-router";

const Card = ({ item, withList, whiteBackground, /*setShowDetails,*/ /*setIsNew,*/ button, old, /*fetchTournamentDetails*/ }) => {
    const navigate = useNavigate();
    const showDetailsHandler = (id) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // fetchTournamentDetails(id);
        // setShowDetails(true);
        // setIsNew(old ? false : true);
        navigate('/tournaments/' + id)
    }

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        // Ensure date and month are 2 digits by padding with 0 if needed
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        
        return `${day}-${month}-${year}`;
    };

    return (
        <div className={[classes.Container, withList && classes.IncreaseContainerHeight].join(" ")}>
            <div className={classes.ImgContainer}>{item.image_url && <img src={item.image_url} alt={item.name} />}</div>
            <h3>{item.name}</h3>
            {item.start_date && item.end_date && <div>
                <span>Date: </span>
                {item.start_date !== item.end_date ? 
                    <span>{formatDate(item.start_date)} to {formatDate(item.end_date)}</span> : 
                    <span>{formatDate(item.start_date)}</span>
                }
            </div>}
            {(item.team_composition?.players > 0 || item.team_composition?.goalkeepers > 0) && ! old &&<div>
                <span>Players Per Team: </span>
                <span>{item.team_composition?.players} players & {item.team_composition?.goalkeepers} goalkeeper</span>
            </div>}
            {item.age_range && <div>
                <span>Age Group: </span>
                <span>{item.age_range.min} - {item.age_range.max} Years</span>
            </div>}
            {item.gender && <div>
                <span>Gender: </span>
                <span className={classes.Gender}>{item.gender}</span>
            </div>}
            {item.joined_teams && !old &&<div>
                <span>Joined Teams: </span>
                <span>{item.joined_teams?.current} / {item.joined_teams?.total}</span>
            </div>}
            {item.status && <div>
                <span>Status: </span>
                {item.status === "Open" ? <span>{item.status} for registration until
                    <span className={classes.RegistrationFees}> {item.registration?.closes}</span>
                </span> : <span>{item.status}</span>}
            </div>}
            {item.registration?.type && !old && <div>
                <span>Registration Type: </span>
                <span>As a {item.registration?.type} only</span>
            </div>}
            {item.registration?.fee && !old && <div>
                <span>Registration Fees: </span>
                <span className={classes.RegistrationFees}>{item.registration?.fee} JD</span>
                <span> / Team</span>
            </div>}
            <Button content={button} whiteBackground={whiteBackground} onClick={() => showDetailsHandler(item.id)}
                disabled={button === "REGISTER NOW" && item.status !== "Open"} />
        </div>
    )
}

export default Card;